import React from 'react';
// Static info bar. No countdown or timers. Never a price here (rule: no price in the top bar).
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-183" data-mp="2fieggpnpknyl">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-184" data-mp="2jietc5v5sr3j">
        Jednorazowa płatność · Dostęp od razu · 7 dni gwarancji
      </p>
    </div>;
}